import { Component, input } from '@angular/core';

import { LexiconModule } from '@galaxy/lexicon';
import { MatIcon } from '@angular/material/icon';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'meeting-analysis-meeting-summary',
  imports: [LexiconModule, MatIcon],
  templateUrl: './meeting-summary.component.html',
  styleUrl: './meeting-summary.component.scss',
  standalone: true,
})
export class MeetingSummaryComponent {
  constructor(
    private clipboard: Clipboard,
    private snackbarService: SnackbarService,
  ) {}
  summary = input.required<string>();
  keyTakeaways = input.required<string[]>();
  actionItems = input.required<string[]>();

  copyToClipboard(copyItem: string | string[]): void {
    const text = Array.isArray(copyItem) ? (copyItem.length ? '• ' + copyItem.join('\n• ') : '') : (copyItem ?? '');

    this.clipboard.copy(text);

    this.snackbarService.openSuccessSnack('COPIED_SUCCESSFULLY');
  }
}
